import { type IRentalIntake } from "@/interfaces/api/rental-intake.interface"
import { RentalIntakeItem } from "@/models/rental-intake-item.model"
import { RentalDispense } from "@/models/rental-dispense.model"
import { ModelFactory } from "@/factories/model-factory"
import { RentalMutation } from "@/models/rental-mutation.model"
import { ShallowRentalIntake } from "@/models/shallow-rental-intake.model"

export class RentalIntake extends RentalMutation implements IRentalIntake {
  public static className = "RentalIntake" // Used for socket communication.

  public static verboseName = "Inhuurmutatie"

  incomingInvoiceReferences: string[]

  rentalIntakeItem: RentalIntakeItem
  counterMutation?: RentalIntake
  counteredBy: ShallowRentalIntake[]
  associatedRentalDispense?: RentalDispense | null

  constructor(rentalIntake: IRentalIntake, managed = false) {
    super(rentalIntake, managed)

    this.incomingInvoiceReferences = rentalIntake.incomingInvoiceReferences ?? []

    this.rentalIntakeItem = ModelFactory.childModel(
      RentalIntakeItem,
      rentalIntake.rentalIntakeItem,
      managed
    )
    this.counterMutation = ModelFactory.childModel(
      RentalIntake,
      rentalIntake.counterMutation,
      managed
    )

    // ShallowRentalIntake is a shallow version of RentalIntake.
    this.counteredBy = ModelFactory.childModels(
      ShallowRentalIntake,
      rentalIntake.counteredBy,
      managed
    )

    this.associatedRentalDispense = ModelFactory.childModel(
      RentalDispense,
      rentalIntake.associatedRentalDispense,
      managed
    )
  }

  public getItem() {
    return this.rentalIntakeItem
  }
}
